exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gift-box-qty div {\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n", ""]);

// exports
